export const APPOINTMENTS_LS_KEY = 'appointments';
export const getAppointmentsLSKey = ({ venueId }) => `apps-${venueId}`;

const RESET_APPOINTMENTS_STATE = 'RESET_APPOINTMENTS_STATE';
const SET_APPOINTMENTS = 'SET_APPOINTMENTS';
const SET_UPDATES = 'SET_UPDATES';
const CLEAR_UPDATES = 'CLEAR_UPDATES';
const SET_FILTER = 'SET_FILTER';
const ADD_DETACHED_SERVICE = 'ADD_DETACHED_SERVICE';
const SET_SENDING_MESSAGE = 'SET_SENDING_MESSAGE';
const SET_UPDATING_PHONE_NUMBER = 'SET_UPDATING_PHONE_NUMBER';

export const clearUpdates = () => ({
  type: CLEAR_UPDATES,
});

export const setAppointments = appointments => ({
  type: SET_APPOINTMENTS,
  appointments,
});

export const setUpdates = updates => ({
  type: SET_UPDATES,
  updates,
});

export const resetAppointmentsState = () => ({
  type: RESET_APPOINTMENTS_STATE,
});

export const setFilter = filter => ({
  type: SET_FILTER,
  filter,
});

export const addDetachedService = externalClassId => ({
  type: ADD_DETACHED_SERVICE,
  externalClassId,
});

export const setSendingMessage = isSendingMessage => ({
  type: SET_SENDING_MESSAGE,
  isSendingMessage,
});

export const setUpdatingPhoneNumber = isUpdatingPhoneNumber => ({
  type: SET_UPDATING_PHONE_NUMBER,
  isUpdatingPhoneNumber,
});

export const FILTER_ALL = 'FILTER_ALL';
export const FILTER_APPOINTMENTS = 'FILTER_APPOINTMENTS';
export const FILTER_CANCELLATIONS = 'FILTER_CANCELLATIONS';
export const FILTER_BLOCK_OFF_TIMES = 'FILTER_BLOCK_OFF_TIMES';

export const INITIAL_STATE = {
  appointments: [],
  updates: [],
  filter: FILTER_ALL,
  loaded: false,
  detachedServices: [],
  sendingMessage: false,
  updatingPhoneNumber: false,
};

export default (state = INITIAL_STATE, { type, ...action }) => {
  switch (type) {
    case SET_APPOINTMENTS:
      return {
        ...state,
        loaded: true,
        appointments: action.appointments,
      };

    case SET_UPDATES:
      return {
        ...state,
        updates: action.updates,
      };

    case CLEAR_UPDATES:
      return {
        ...state,
        appointments: state.updates,
        updates: [],
      };

    case SET_FILTER:
      return {
        ...state,
        filter: action.filter,
      };

    case ADD_DETACHED_SERVICE:
      return {
        ...state,
        detachedServices: [...state.detachedServices, action.externalClassId],
      };

    case RESET_APPOINTMENTS_STATE:
      return INITIAL_STATE;

    case SET_SENDING_MESSAGE:
      return {
        ...state,
        sendingMessage: action.isSendingMessage,
        messageSent: false,
      };
    case SET_UPDATING_PHONE_NUMBER:
      return {
        ...state,
        updatingPhoneNumber: action.isUpdatingPhoneNumber,
      };

    default:
      return state;
  }
};
